module.exports = __webpack_public_path__ + "img/Sierra-Leone.8724af5f.png";